import { render } from "./TwilioThirdColView.vue?vue&type=template&id=8c6fae12&scoped=true"
import script from "./TwilioThirdColView.vue?vue&type=script&lang=js"
export * from "./TwilioThirdColView.vue?vue&type=script&lang=js"

import "./TwilioThirdColView.vue?vue&type=style&index=0&id=8c6fae12&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6fae12"]])

export default __exports__